import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { IntercomGetResponseType } from "@sellar-io/api-v2/types";

export const useIntercomHmac = <TData = IntercomGetResponseType>(
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `intercom/hmac`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
    enabled: !!user && !!business,
  });
};
